import React from 'react'
import type { Lang } from './types'

interface Props {
  lang: Lang
}

/**
 * StoreHeroV2
 * One image, one big word — full-bleed dark hero, mirrors BusinessHeroV2.
 * Sits below the solid HeaderV2 (white-bg, black-text) per the V2 site rule.
 */
const StoreHeroV2: React.FC<Props> = ({ lang }) => {
  const title = lang === 'zh' ? '門市' : 'Stores'
  const alt = lang === 'zh' ? 'ONGU Studio 門市空間' : 'ONGU Studio store space'

  return (
    <section className='relative h-[70vh] min-h-[480px] w-full overflow-hidden bg-black'>
      <div className='absolute inset-0'>
        <img
          src='https://file.lumi.new/p373839333138763776/SPF2016978764204675072.webp'
          alt={alt}
          className='h-full w-full object-cover'
        />
        <div className='absolute inset-0 bg-black/30' />
        <div className='absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/55 to-transparent' />
      </div>

      <div className='relative z-10 mx-auto flex h-full max-w-[1600px] items-end px-6 pb-12 md:px-10 md:pb-16'>
        <h1
          className='text-white'
          style={{
            fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
            fontWeight: 400,
            fontSize: 'clamp(2.25rem, 5vw, 4rem)',
            letterSpacing: '0.02em',
            lineHeight: 1.1,
          }}
        >
          {title}
        </h1>
      </div>
    </section>
  )
}

export default StoreHeroV2
